import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorItemProps } from "@/v2-backoffice-client/components/selector"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import { useTenantUserAddManyMutation } from "@/v2-backoffice-client/tenant/user/add/many/tenant.user.add.many.mutation"

export type TenantUserAddManySelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children" | "onSelect"
> & {
  tenant: TenantFragment
  userIds: number[]
  userTenantTypeCode?: number
  onSelect?(): void
}

function TenantUserAddManySelectorItem(
  props: TenantUserAddManySelectorItemProps,
) {
  const {
    tenant,
    userIds,
    userTenantTypeCode,
    onSelect,
    ...selectorItemProps
  } = props

  const [addMany, { loading, error }] = useTenantUserAddManyMutation()
  errorToast(error, {
    title: "Failed to add users to team",
  })

  return (
    <Selector.Item
      isLoading={loading}
      value={`${tenant.Name} ${tenant.Id}`}
      onSelect={() => {
        addMany({
          variables: { tenantId: tenant.Id, userIds, userTenantTypeCode },
        })
        onSelect?.()
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        isRemoved={tenant.IsDeleted}
        primary={tenant.Name}
        secondary={`${tenant.CustomerName} - ${tenant.UserCount} users`}
      />
    </Selector.Item>
  )
}

export default TenantUserAddManySelectorItem
